/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How long is the ${i?.label} typing test?`)
};

const es_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cuánto dura el test de mecanografía de ${i?.label}?`)
};

const de_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wie lange dauert der ${i?.label} Tipptest?`)
};

const nl_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hoe lang duurt de typetest van ${i?.label}?`)
};

const fr_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Combien de temps dure le test de frappe de ${i?.label} ?`)
};

const it_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto dura il test di digitazione da ${i?.label}?`)
};

const pt_br2_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto tempo dura o teste de digitação de ${i?.label}?`)
};

const pt_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto tempo dura o teste de escrita de ${i?.label}?`)
};

const ja_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}タイピングテストの時間は？`)
};

const zh_typing_variant_faq1_q = /** @type {(inputs: { label: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label}打字测试要持续多久？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ label: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_variant_faq1_q = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_variant_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_variant_faq1_q", locale)
	if (locale === "en") return en_typing_variant_faq1_q(inputs)
	if (locale === "es") return es_typing_variant_faq1_q(inputs)
	if (locale === "de") return de_typing_variant_faq1_q(inputs)
	if (locale === "nl") return nl_typing_variant_faq1_q(inputs)
	if (locale === "fr") return fr_typing_variant_faq1_q(inputs)
	if (locale === "it") return it_typing_variant_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_variant_faq1_q(inputs)
	if (locale === "pt") return pt_typing_variant_faq1_q(inputs)
	if (locale === "ja") return ja_typing_variant_faq1_q(inputs)
	return zh_typing_variant_faq1_q(inputs)
};